import { useState } from 'react';

import ClassicSignIn from 'views/auth/sign-in';
import UnifiedSignIn from 'views/auth/unified-sign-in';

export default function SignInPage() {
	const [useClassicLogin, setUseClassicLogin] = useState(false);

	if (useClassicLogin) {
		return <ClassicSignIn onSwitchToUnified={() => setUseClassicLogin(false)} />;
	}

	return <UnifiedSignIn onSwitchToClassic={() => setUseClassicLogin(true)} />;
}
